import type { UtmAttribution } from "../tcEventsCollector/tcEvent"

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const

/**
 * Return a set of UTM values from the current URL query string
 * Returns undefined when no valid UTM values are found
 */
export function getUtmAttribution(): UtmAttribution | undefined {
  if (typeof window === "undefined") return undefined

  try {
    const searchParams = new URLSearchParams(window.location.search)
    const attribution: UtmAttribution = {}

    UTM_KEYS.forEach((key) => {
      const value = searchParams.get(key)?.trim()
      if (value) attribution[key] = value
    })

    return Object.keys(attribution).length > 0 ? attribution : undefined
  } catch {
    return undefined
  }
}
